import React, { useEffect, Fragment, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import PerfectScrollBar from 'react-perfect-scrollbar';

import { FaPhone } from 'react-icons/fa';
import { MdPrint, MdEmail } from 'react-icons/md';

import PieProfile from '../../../hightchart/pieProfile';
import { sum, map } from 'lodash';
import { numberFormat, StringToDouble } from '../../../../utils';
import { translate } from 'react-i18next';

const colors = [
  '#6558FF',
  '#F7B500',
  '#97D653',
  '#64A5E7',
  '#ED561B',
  '#DDDF00',
  '#24CBE5',
  '#64E572',
  '#FF9655',
];

const Profile = (props) => {
  const [loadMore, setLoadMore] = useState(false);
  const _handleLoadProfile = () => {
    props.loadProfile(props.symbol);
  };

  const renderIntroduction = (introduction) => {
    if (!introduction) return null;

    const listIntro = introduction.split('\r\n');
    console.log(listIntro);

    if (loadMore)
      return (
        <div>
          {listIntro.map((item, idx) => (
            <p key={idx} className="mb-0 fz-14">
              {item}
            </p>
          ))}
        </div>
      );

    return (
      <div>
        <p className="mb-0 fz-14">
          {listIntro[0]}
          <a
            style={{ color: '#1BA0E1' }}
            className="font-weight-bold ml-2"
            onClick={() => setLoadMore(!loadMore)}
          >
            Read more...
          </a>
        </p>
      </div>
    );
  };

  const renderOwnership = (ownership) => {
    const _dt = sum(map(ownership, (o) => StringToDouble(o.value)));
    const _other = 100 - _dt;
    return (
      <ul className="list-unstyled">
        {ownership.map((item, idx) => (
          <li key={'ownership_' + idx} className="mt-1">
            <p className="mb-0 content-read fz-14 font-weight-bold d-flex align-items-center">
              <span
                style={{
                  backgroundColor: colors[idx % 9],
                  width: '20px',
                  height: '10px',
                  borderRadius: '4px',
                }}
              ></span>
              <span className="ml-2">{item.value + '%'}</span>
            </p>
            <p className="mb-0 title-read fz-10">{item.name}</p>
          </li>
        ))}
        {_other !== 0 && (
          <li className="mt-1">
            <p className="mb-0 content-read fz-14 font-weight-bold d-flex align-items-center">
              <span
                style={{
                  backgroundColor: colors[ownership.length % 9],
                  width: '20px',
                  height: '10px',
                  borderRadius: '4px',
                }}
              ></span>
              <span className="ml-2">{_other.toFixed(2) + '%'}</span>
            </p>
            <p className="mb-0 title-read fz-10">{'Khác'}</p>
          </li>
        )}
      </ul>
    );
  };

  useEffect(() => {
    _handleLoadProfile();
  }, [props.symbol]);

  const { stockManage, associate, t } = props;
  // console.log(associate);
  return (
    <div className="tab-profile">
      <div className="d-flex flex-column pt-2 pb-2 w-100">
        {/* <PerfectScrollBar
          style={{
            height: 'calc( 100vh - 310px )',
          }}
          className="d-flex flex-column pt-2 pb-2 w-100"
        > */}
        <div className="d-flex w-100">
          <Col md="4" className="br-1 pr-0 pl-0">
            <p
              className="mb-0 fz-12 title-read text-center text-uppercase font-weight-bold"
              style={{ padding: '4px', backgroundColor: 'aliceblue' }}
            >
              {t('txt-label-legal-representative')}
            </p>
            <PerfectScrollBar
              style={{
                height: 'calc( 100vh - 345px )',
              }}
            >
              <ul className="list-unstyled">
                {stockManage &&
                  stockManage.data &&
                  stockManage.data.leadership &&
                  stockManage.data.leadership.map((item, idx) => (
                    <li key={'leadership_' + idx} className="mt-1">
                      <p className="mb-0 content-read fz-14 font-weight-bold">
                        {item.name}
                      </p>
                      <p className="mb-0 title-read fz-14">
                        {item.main_position}
                      </p>
                    </li>
                  ))}
              </ul>
            </PerfectScrollBar>
          </Col>
          <Col md="8" className="p-0">
            <PerfectScrollBar style={{
                height: 'calc( 100vh - 315px )',
              }}
              className="d-flex flex-column w-100">
              <Row className="p-0">
                <Col>
                  {stockManage &&
                    stockManage.data &&
                    stockManage.data.ownership && (
                      <PieProfile data={stockManage.data.ownership} />
                    )}
                </Col>
                <Col>
                  <p className="mb-0 fz-12 title-read text-uppercase">
                    {t('txt-label-major-shareholders')}
                  </p>
                  {stockManage &&
                    stockManage.data &&
                    stockManage.data.ownership &&
                    renderOwnership(stockManage.data.ownership)}
                </Col>
              </Row>
              <Row className="m-0">
                <h5
                  className="text-center w-100 mb-0"
                  style={{ padding: '4px', backgroundColor: 'aliceblue' }}
                >
                  Công ty liên kết
                </h5>
                <div className="d-flex w-100">
                  <table className="table table-borderless">
                    <thead>
                      <tr>
                        <th>Tên công ty</th>
                        <th>Vốn điều lệ</th>
                        <th>Tỷ lệ nắm giữ</th>
                      </tr>
                    </thead>
                    <tbody>
                      {associate &&
                        associate.map((item, index) => (
                          <tr key={index}>
                            <td>{item.Name}</td>
                            <td className="text-right">
                              {numberFormat(item.Value / 1000000000)} tỷ VNĐ
                            </td>
                            <td className="text-center">{item.OwnerRatio}%</td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </Row>
            </PerfectScrollBar>
          </Col>
        </div>
      </div>
    </div>
  );
};

export default translate('translations')(Profile);
